<template>
    <div class="login-b">

        <div class="name-b">
            <i class="el-icon-s-custom"></i>
        </div>
        
        <div class="logout-b" @click="logout">
            <span>登出</span>
        </div>
        
    </div>
</template>

<script>
    export default {
        name: '',
        data() {
          	return {
          	}
        },

        methods: {

            async logout() {

                try {

                   await this.$API.employee.reqLogout();

                } catch (error) {

                    this.$message.error('登出异常');

                } finally {

                    //清除本地token
                    localStorage.removeItem('TOKEN');

                    //浏览器跳转
                    this.$router.push('/login')
                }

            }
        }
    }      
</script>

<style scoped>
    .login-b {
        display: flex;
        align-items: center; 
        box-shadow: 0 0 5px #deeaf5a8;
        border-radius: 9px;
    }

    .name-b {
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 20px;
        text-align: center;
        color: #333;
        background-color: #ebebeb;
        border-radius: 9px;
        overflow: hidden;
        cursor: default;
    }

    .logout-b {
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        text-align: center;

        display: none;
    }

    .logout-b span:hover {
        color: #606266;
        cursor: pointer;
    }

    .login-b:hover .logout-b {
        display: block;
    }

</style>